import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import { Cake, ArrowForward } from "@mui/icons-material";
import { MONTH_NAMES, parseDob } from "../utils/birthdayUtils";

const BirthdayMonths = () => {
  const navigate = useNavigate();
  const [members, setMembers] = useState([]);
  const currentMonth = new Date().getMonth();

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const snap = await getDocs(
          query(collection(db, "members"), orderBy("createdAt", "desc")),
        );
        setMembers(
          snap.docs
            .map((d) => ({ _id: d.id, ...d.data() }))
            .filter((m) => m.status === "approved"),
        );
      } catch (err) {
        console.error(err);
      }
    };
    fetchMembers();
  }, []);

  const countsByMonth = useMemo(() => {
    const counts = Array(12).fill(0);
    members.forEach((m) => {
      const parsed = parseDob(m.dob);
      if (parsed) counts[parsed.month] += 1;
    });
    return counts;
  }, [members]);

  return (
    <div className="min-h-screen bg-[#f5f7fe] p-3 sm:p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-xl bg-[#fff7ed] flex items-center justify-center flex-shrink-0">
            <Cake style={{ color: "#ea580c", fontSize: 20 }} />
          </div>
          <div>
            <h1 className="text-xl sm:text-2xl font-bold text-[#000C66] font-aref">
              Birthdays
            </h1>
            <p className="text-gray-400 text-xs font-abel">
              Pick a month to see its celebrants
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {MONTH_NAMES.map((name, i) => {
            const isCurrent = i === currentMonth;
            return (
              <button
                key={name}
                onClick={() => navigate(`/birthdays/${i}`)}
                className={`text-left p-5 rounded-2xl border transition hover:shadow-md hover:-translate-y-0.5 ${
                  isCurrent
                    ? "bg-[#000C66] border-[#000C66]"
                    : "bg-white border-gray-100"
                }`}
              >
                <div className="flex items-center justify-between mb-3">
                  <div
                    className={`w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 ${
                      isCurrent ? "bg-white/15" : "bg-[#fff7ed]"
                    }`}
                  >
                    <Cake
                      style={{
                        color: isCurrent ? "#FFC000" : "#ea580c",
                        fontSize: 18,
                      }}
                    />
                  </div>
                  {isCurrent && (
                    <span className="text-[10px] font-abel font-semibold px-2 py-0.5 bg-[#FFC000] text-[#000C66] rounded-full">
                      Current
                    </span>
                  )}
                </div>
                <h2
                  className={`text-lg font-bold font-aref mb-1 ${
                    isCurrent ? "text-white" : "text-[#000C66]"
                  }`}
                >
                  {name}
                </h2>
                <div className="flex items-center justify-between">
                  <p
                    className={`text-xs font-abel ${
                      isCurrent ? "text-white/70" : "text-gray-400"
                    }`}
                  >
                    {countsByMonth[i]} celebrant
                    {countsByMonth[i] !== 1 ? "s" : ""}
                  </p>
                  <ArrowForward
                    style={{
                      fontSize: 14,
                      color: isCurrent ? "rgba(255,255,255,0.6)" : "#d1d5db",
                    }}
                  />
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BirthdayMonths;
